import { css } from '@sitebase/emotion';
import { colorPrimary500, colorPrimary200, colorPrimary50, colorPrimary30, sizeBase, sizeNormal, sizeTiny, fontDefaults } from '../settings';
import { cssSizes } from './helpers';

var _ref = ';cursor:pointer;display:flex;align-items:center;justify-content:space-between;color:';
var _ref2 = ';padding:';
var _ref3 = ' ';
var _ref4 = ';margin:0 ';
var _ref5 = ';box-sizing:border-box;border-top:1px solid ';
var _ref6 = ';';
var _ref7 = ';&:hover,&:focus{background-color:';
var _ref8 = ';color:';
var _ref9 = ';outline:none;}';
export var selectOption = function selectOption(size) {
  return (/*#__PURE__*/css(fontDefaults, _ref, colorPrimary200, _ref2, sizeBase, _ref3, sizeTiny, _ref4, sizeNormal, _ref5, colorPrimary50, _ref6, cssSizes[size], _ref7, colorPrimary30, _ref8, colorPrimary500, _ref9)
  );
};

export var selectOptionSelected = /*#__PURE__*/css('background-color:', colorPrimary30, ';color:', colorPrimary500, ';');

export var selectTick = /*#__PURE__*/css('color:', colorPrimary200, ';margin-right:14px;');